import moment from 'moment';

export default {
  methods: {
    formatFromNow(dt) {
      return moment(dt).fromNow();
    },
    formatBool(val) {
      return val ? 'Yes' : 'No';
    },
  },
};
